"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidTime = exports.isValidDate = void 0;
__exportStar(require("./Forecast.schema"), exports);
__exportStar(require("./ForecastsCopyToOfferedParams.schema"), exports);
__exportStar(require("./ForecastsCopyToOfferedResult.schema"), exports);
__exportStar(require("./StrategicOverviewCopyToBiddingParams.schema"), exports);
__exportStar(require("./StrategicOverviewCopyToBiddingResult.schema"), exports);
__exportStar(require("./OfferedReport.schema"), exports);
__exportStar(require("./Notification.schema"), exports);
__exportStar(require("./BiddingCalculated.schema"), exports);
var DayTime_schema_1 = require("./common/DayTime.schema");
Object.defineProperty(exports, "isValidDate", { enumerable: true, get: function () { return DayTime_schema_1.isValidDate; } });
var DayTime_schema_2 = require("./common/DayTime.schema");
Object.defineProperty(exports, "isValidTime", { enumerable: true, get: function () { return DayTime_schema_2.isValidTime; } });
